// AIFeatureToggles.js — Toggle panel for AI/ML search enhancement features
import React, { useState } from 'react';

const AI_FEATURES = [
  {
    key: 'enable_hyde',
    label: 'HyDE',
    fullName: 'Hypothetical Document Embedding',
    description: 'Generates a synthetic movie plot from your query for better semantic matching',
    icon: '📝',
  },
  {
    key: 'enable_query_expansion',
    label: 'Query Expansion',
    fullName: 'LLM Query Expansion',
    description: 'Expands your search with synonyms and related concepts via LLM',
    icon: '🔄',
  },
  {
    key: 'enable_rrf',
    label: 'RRF Fusion',
    fullName: 'Reciprocal Rank Fusion',
    description: 'Merges trie lexical + pgvector semantic results into one optimally ranked list',
    icon: '🔀',
  },
  {
    key: 'enable_reranker',
    label: 'Re-ranker',
    fullName: 'LLM Cross-encoder Re-ranking',
    description: 'LLM scores each result for relevance, then re-sorts by quality',
    icon: '🏆',
  },
];

function AIFeatureToggles({ featureFlags, onToggle, aiFeaturesInfo }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const activeCount = Object.values(featureFlags).filter(Boolean).length;

  return (
    <div className="ai-toggles-container">
      <button
        className="ai-toggles-header"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <span className="ai-toggles-header-left">
          <span className="ai-toggles-icon">⚡</span>
          <span className="ai-toggles-title">AI Features</span>
          {activeCount > 0 && (
            <span className="ai-toggles-badge">{activeCount} active</span>
          )}
        </span>
        <span className={`ai-toggles-chevron ${isExpanded ? 'expanded' : ''}`}>
          ▾
        </span>
      </button>

      {isExpanded && (
        <div className="ai-toggles-panel">
          {AI_FEATURES.map((feature) => {
            const isOn = featureFlags[feature.key] || false;
            const info = aiFeaturesInfo?.[feature.key.replace('enable_', '')] || {};

            return (
              <div
                key={feature.key}
                className={`ai-toggle-row ${isOn ? 'active' : ''}`}
              >
                <div className="ai-toggle-info">
                  <div className="ai-toggle-label">
                    <span className="ai-toggle-feature-icon">{feature.icon}</span>
                    <span className="ai-toggle-name">{feature.label}</span>
                    {info.applied && (
                      <span className="ai-toggle-applied-badge">
                        ✓ {info.latency_ms}ms
                      </span>
                    )}
                  </div>
                  <div className="ai-toggle-description">{feature.description}</div>
                </div>
                <label className="ai-toggle-switch">
                  <input
                    type="checkbox"
                    checked={isOn}
                    onChange={() => onToggle(feature.key)}
                    aria-label={`Toggle ${feature.fullName}`}
                  />
                  <span className="ai-toggle-slider"></span>
                </label>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AIFeatureToggles;
